export const isArrayOf = <T>(data: T[], type: string): boolean => {
  return Array.isArray(data) && data.every((n) => typeof n === type);
};
